import { styled } from '@mui/material/styles';
import { Snackbar } from '@mui/material';

export const StyledSnackbar = styled(Snackbar)(({ theme }) => ({
  '& .MuiSnackbarContent-root': {
    backgroundColor: theme.palette.grey[800],
    color: theme.palette.common.white,
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[6],
    
    '& .MuiSnackbarContent-message': {
      padding: 0,
    },
    
    '& .MuiSnackbarContent-action': {
      marginRight: 0,
      paddingLeft: theme.spacing(1),
    },
  },
  
  '& .MuiAlert-root': {
    borderRadius: theme.shape.borderRadius,
    fontWeight: theme.typography.fontWeightMedium,
    
    '& .MuiAlert-icon': {
      fontSize: '1.25rem',
    },
    
    '& .MuiAlert-message': {
      fontSize: theme.typography.body1.fontSize,
    },
    
    '& .MuiAlert-action': {
      paddingTop: 0,
      
      '& .MuiIconButton-root': {
        padding: theme.spacing(0.25),
      },
    },
  },
})); 